import AppContainerFromCreditControl from '../../../credit-control/src/components/AppContainer';
import { useUserContext } from '../providers/UserContextProvider';

interface CreditControlWithUserContextProps {
  apiUrl: string;
  financialsApiUrl?: string;
}

/**
 * Wrapper component that bridges UserContextProvider with the credit-control AppContainer.
 * Passes the userContext companies to CompanyProvider via the settings prop.
 */
export function CreditControlWithUserContext({
  apiUrl,
  financialsApiUrl,
}: CreditControlWithUserContextProps): React.ReactElement {
  const { companies, isLoading } = useUserContext();

  return (
    <AppContainerFromCreditControl
      settings={{
        apiUrl,
        financialsApiUrl,
        host: 'app-prod',
        externalCompanies: companies,
        externalCompaniesLoading: isLoading,
      }}
    />
  );
}
